import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { siteAuditDocumentsReportQueryOptions } from '~bank-reports/service/siteAuditDocumentsReportQueryOptions'
import { siteAuditDocumentsReportFilterParamsSchema } from '~bank-reports/types/SiteAuditDocumentsReport'

export const siteAuditDocumentsReportRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: 'compliance-review',
    validateSearch: (search) => siteAuditDocumentsReportFilterParamsSchema.parse(search),
    loaderDeps: ({ search }) => search,
    loader: ({ cause, deps, context }) => {
      if (cause === 'stay') {
        return null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(siteAuditDocumentsReportQueryOptions(deps))
    },
    component: lazyRouteComponent(() => import('./SiteAuditDocumentsReport'))
  })
